module.exports = __webpack_public_path__ + "static/16-4113c64f98fd59aaa28a161f92746dad.jpg";